const sizeVariants = document.querySelectorAll('.size_Option');
const btnAddToCart = document.querySelector('.product-form__buttons .product-form__submit');
const tagOutofStock = document.querySelector('.product__info-container .outofstock');
const btnTextAddToCart = document.querySelector('.product-form__buttons .text_add_to_cart');
const btnTextOutofStock = document.querySelector('.product-form__buttons .text_sold_out');

  sizeVariants.forEach(size=>{
    size.addEventListener("click", (event) => {
      if(size.hasAttribute("outofstock")){
        btnAddToCart.setAttribute("disabled", "disabled");
        btnAddToCart.classList.add("disable");
        tagOutofStock.classList.remove("hide");
        btnTextAddToCart.classList.add("hide");
        btnTextOutofStock.classList.remove("hide");
      }else{
        btnAddToCart.classList.remove("disable");
        tagOutofStock.classList.add("hide");
        btnTextAddToCart.classList.remove("hide");
        btnTextOutofStock.classList.add("hide");        
      }
    });
  });

document.addEventListener("DOMContentLoaded", function () {
    const radioButtons = document.querySelectorAll('input[type="radio"][data-variant-id]');

    radioButtons.forEach(radio => {
        radio.addEventListener("change", function () {
            const referenceId = this.id.split('-')[0];
            const variantId = this.dataset.variantId;

            // Buscamos el formulario relacionado
            const relatedForm = document.getElementById('product-form-' + referenceId);
            if (relatedForm) {
                // Busca el input hidden solo dentro de este formulario
                const hiddenInput = relatedForm.querySelector('.variante-' + referenceId);
                console.log(hiddenInput); // Verifica que se selecciona correctamente
                if (hiddenInput) {
                    hiddenInput.value = variantId;  // Actualiza el valor
                    console.log('Nuevo valor para el input hidden:', hiddenInput.value);
                } else {
                    console.log('No se encontró el input hidden dentro del formulario.');
                }
            } else {
                console.log('No se encontró el formulario relacionado con ID: product-form-' + referenceId);
            }
        });
    });
});
